import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const LMT_ENHCMT_perfiosOnlineBanking_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_perfiosOnlineBanking_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({
      type: 'LMT_ENHCMT_perfiosOnlineBanking_API_CALL/pending',
      payload: {},
    });
    const { perfiosOnlineBankingPayload, successFn, errorFn } = payload;
    const { institutionId, returnUrl, customerId, authorization, requestType } =
      perfiosOnlineBankingPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      route: 'perfiosforweb',
      payload: {
        customerId,
        returnUrl,
        requestType: requestType ? requestType : 'BS_ONLINE_TXN',
        institutionId,
        appId: APP_ID,
        appVersion: APP_VERSION,
        journeyType: 'LIMIT_ENHANCE',
      },
      otherPayloadDetailsPresent: true,
      headers: { authorization, customerid: customerId },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({
          type: 'LMT_ENHCMT_perfiosOnlineBanking_API_CALL/fulfilled',
          payload: res,
        });
        if (successFn) successFn(res);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LMT_ENHCMT_perfiosOnlineBanking_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
    });
  }
);

export const LMT_ENHCMT_perfiosOnlineBanking_API_CALL_extrareducer = {
  [LMT_ENHCMT_perfiosOnlineBanking_API_CALL.pending]: (state, action) => {
    state.perfiosOnlineBankingAPICall.isLoading = true;
  },
  [LMT_ENHCMT_perfiosOnlineBanking_API_CALL.fulfilled]: (state, action) => {
    state.perfiosOnlineBankingAPICall.isLoading = false;
    state.perfiosOnlineBankingAPICall.isSuccess = true;
    state.perfiosOnlineBankingAPICall.isError = false;
    state.perfiosOnlineBankingAPICall.response = action.payload;
  },
  [LMT_ENHCMT_perfiosOnlineBanking_API_CALL.rejected]: (state, action) => {
    state.perfiosOnlineBankingAPICall.isLoading = false;
    state.perfiosOnlineBankingAPICall.isSuccess = false;
    state.perfiosOnlineBankingAPICall.isError = true;
    state.perfiosOnlineBankingAPICall.response = action.payload;
  },
};
